import React, { useState, useContext } from "react";
import ValetApi from "../api/Api";
import { asArray } from "../utility/asArray";
import userContext from "../auth/UserContext";
import "./AdminApproval.css";

const ROLE_LABEL_BY_ID = {
    1: "valet",
    2: "supervisor",
    3: "manager",
    4: "director",
    5: "admin",
};

const AdminApproval = () => {
    const { userDetail } = useContext(userContext);

    const [pendingUsers, setPendingUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [backendMsg, setBackendMsg] = useState("");

    const podiumIds = Array.isArray(userDetail?.accessiblePodiums) ? userDetail.accessiblePodiums.map((p) => p.id) : [];

    async function fetchPending() {
        setLoading(true);
        setBackendMsg("");
        try {
            console.log("Fetching pending users for podiumIds:", podiumIds);
            const res = await ValetApi.getPendingUsersByPodiumId(podiumIds);
            setPendingUsers(asArray(res?.data?.users));
            setFetched(true);
            if (res?.data?.message) setBackendMsg(res.data.message);
        } catch (err) {
            console.error("AdminApproval.getPendingUsers error:", err);
            setPendingUsers([]);
            setFetched(true);
            const msg = err?.response?.data?.error?.message || err?.response?.data?.message || "No pending registration requests.";
            setBackendMsg(msg);
        } finally {
            setLoading(false);
        }
    }

    async function handleApprove(userId) {
        try {
            await ValetApi.approveUser(userId);
            setPendingUsers((list) => list.filter((u) => u.id !== userId));
        } catch (err) {
            console.error("AdminApproval.approveUser error:", err);
            alert("Failed to approve user. See console.");
        }
    }

    async function handleReject(userId) {
        try {
            await ValetApi.rejectUser(userId);
            setPendingUsers((list) => list.filter((u) => u.id !== userId));
        } catch (err) {
            console.error("AdminApproval.rejectUser error:", err);
            alert("Failed to reject user. See console.");
        }
    }

    function formatRole(roleId) {
        const normalizedId = Number(roleId);
        return ROLE_LABEL_BY_ID[normalizedId] || String(roleId || "unknown");
    }

    return (
        <div className="admin-approval-section">
            <h3>Approve Registrations</h3>
            <button
                onClick={fetchPending}
                disabled={loading}
                className="admin-approval-fetch-btn">
                {loading ? "Loading..." : "Show Pending Users"}
            </button>
            {fetched &&
                (pendingUsers.length === 0 ? (
                    <div className="admin-approval-msg">{backendMsg ? backendMsg : "No pending registration requests."}</div>
                ) : (
                    <div className="admin-approval-table-wrap">
                        <table className="admin-approval-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pendingUsers.map((u) => (
                                    <tr key={u.id}>
                                        <td data-label="Name">
                                            {u.firstName} {u.lastName}
                                        </td>
                                        <td data-label="Username">{u.username}</td>
                                        <td data-label="Email">{u.email}</td>
                                        <td data-label="Role">{formatRole(u.roleId)}</td>
                                        <td
                                            data-label="Actions"
                                            className="admin-approval-actions">
                                            <button
                                                className="admin-approval-btn admin-approval-approve"
                                                onClick={() => handleApprove(u.id)}>
                                                Approve
                                            </button>
                                            <button
                                                className="admin-approval-btn admin-approval-reject"
                                                onClick={() => handleReject(u.id)}>
                                                Reject
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}
        </div>
    );
};

export default AdminApproval;
